import { DASHBOARDS, LOADING } from './DashboardsActions';

const INITIAL_STATE = {
  loading: false,
  boards: [],
  page: 0,
  total: 0,
};

const DashboardsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DASHBOARDS: {
      return {
        ...state,
        loading: false,
        boards: action.data.results,
        page: action.data.page,
        total: action.data.total,
      };
    }
    case LOADING: {
      return {
        ...state,
        loading: action.val,
      };
    }
  }

  return state;
};

export default DashboardsReducer;
